import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';

import { ICON_MAP } from 'src/utils/constants';

const CellLinkWithIcon = ({
    toPath,
    linkTitle,
    hasPermissions = true,
}: {
    toPath: string;
    linkTitle?: string;
    hasPermissions?: boolean;
}) => {
    return hasPermissions && linkTitle ? (
        <Link
            to={toPath}
            className="text-primary-700 hover:text-primary-600 cursor-pointer font-medium whitespace-nowrap"
        >
            {linkTitle}
            <FontAwesomeIcon icon={ICON_MAP.ARROW_UP_RIGHT} />
        </Link>
    ) : (
        <div>{linkTitle ?? '-'}</div>
    );
};

export default CellLinkWithIcon;
